/**
 * Event **write layer** — the `createEvent` mutation injected onto the shared
 * `pApi` (Oxbo-P client) so the Well record can add a new job (event) and become
 * the primary entry point for one. The shared contract files (`@api/pApi`,
 * `@api/types`) stay untouched: the hook is generated by `pApi.injectEndpoints`,
 * keeping branches merge-clean.
 *
 * API contract (Oxbo-P, `/v1`, JWT):
 *   POST /v1/events   body EventCreate   → EventOut   (422 on a bad event_type)
 *
 * On success we invalidate the well's events list (`{type:"Event", id:"WELL-"+
 * well_uwi}` — mirroring how `getWellEvents` tags it) so the record's event
 * selector refetches, plus the tenant-wide `ALL` bucket the Explorer badges read.
 */
import { pApi } from "@api/pApi";
import type { EventOut, EventCreate } from "@api/types";

export const eventEntryApi = pApi.injectEndpoints({
  endpoints: (b) => ({
    createEvent: b.mutation<EventOut, EventCreate>({
      query: (body) => ({ url: "/events", method: "POST", body }),
      invalidatesTags: (_r, _e, body) => [
        { type: "Event", id: `WELL-${body.well_uwi}` },
        { type: "Event", id: "ALL" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useCreateEventMutation } = eventEntryApi;
